<div class='container' [class.fast-scroll]='content.fastScroll' [class.scroll-lock]='content.scrollLock' #container>
  <ng-container *ngFor='let item of content.messages;let i=index'>
    <chatbot-message-switch [content]='content' [item]='item' [index]="i" class="chatbot-message-{{item.kind}}-type"
                        [style.display]='content.visibleRevision < item.revision ? "none" : "block"'>
    ></chatbot-message-switch>
  </ng-container>
</div>
